import ServiceTemplate from '@/components/ServiceTemplate';

export default function DataProtection() {
  const data = {
    title: 'Data Protection and Privacy Services',
    subtitle: 'Comprehensive data protection compliance including GDPR, CCPA, and privacy policy development.',
    overviewTitle: 'Why Data Protection Matters',
    overviewImage: 'https://images.unsplash.com/photo-1563986768609-322da13575f3',
    description: [
      'Data protection laws like GDPR and CCPA impose significant requirements on businesses collecting personal information. Compliance requires proper policies, procedures, and technical safeguards to protect user data.',
      'Our data protection service helps businesses navigate complex privacy laws, implement required policies, and establish compliant data handling practices.',
      'We provide comprehensive privacy compliance including policy development, data mapping, consent mechanisms, and ongoing compliance support.'
    ],
    benefits: [
      { title: 'Regulatory Compliance', description: 'Meet GDPR, CCPA, and other privacy law requirements.' },
      { title: 'Privacy Policies', description: 'Comprehensive, compliant privacy policies.' },
      { title: 'Data Mapping', description: 'Understand what data you collect and how it\'s used.' },
      { title: 'Consent Management', description: 'Implement proper consent mechanisms.' },
      { title: 'Breach Response', description: 'Establish data breach response procedures.' },
      { title: 'Ongoing Support', description: 'Continuous privacy compliance guidance.' }
    ],
    process: [
      { title: 'Setup & Configuration', description: 'Initial assessment and configuration of monitoring parameters tailored to your needs.' },
      { title: 'Continuous Monitoring & Analysis', description: 'Ongoing surveillance and expert analysis of findings with actionable intelligence.' },
      { title: 'Action & Protection', description: 'Strategic guidance and implementation of protection measures when threats are identified.' }
    ],
    pricing: [
      {
        name: 'Consultation',
        description: 'Initial assessment',
        price: '$299',
        period: 'Per session',
        features: [
          '90-minute consultation',
          'Situation analysis',
          'Strategy recommendations',
          'Action plan',
          'Written summary',
          'Follow-up email support'
        ]
      },
      {
        name: 'Retainer',
        description: 'Ongoing advisory',
        price: '$1,499',
        period: 'Per month',
        featured: true,
        features: [
          'Monthly strategy sessions',
          'Unlimited email support',
          'Priority phone access',
          'Document review',
          'Compliance monitoring',
          'Quarterly reporting',
          'Dedicated attorney'
        ]
      },
      {
        name: 'Project-Based',
        description: 'Custom engagement',
        price: 'Custom',
        period: 'Based on scope',
        features: [
          'Scope-based pricing',
          'Dedicated team',
          'Project management',
          'Milestone deliverables',
          'All work product included',
          'Comprehensive reporting',
          'Executive support'
        ]
      }
    ],
    faqs: [
      { question: 'What is GDPR?', answer: 'General Data Protection Regulation is EU law governing personal data collection and processing, applying to any business serving EU residents.' },
      { question: 'What is CCPA?', answer: 'California Consumer Privacy Act gives California residents rights over their personal information and imposes obligations on businesses collecting their data.' },
      { question: 'Do these laws apply to my business?', answer: 'GDPR applies if you serve EU residents; CCPA applies to larger businesses serving California consumers. State privacy laws are proliferating.' },
      { question: 'What is a privacy policy?', answer: 'A privacy policy discloses what personal information you collect, how it\'s used, who it\'s shared with, and user rights regarding their data.' },
      { question: 'What are user rights?', answer: 'Privacy laws grant rights including access, deletion, correction, data portability, and opt-out of sales/targeted advertising.' },
      { question: 'What about cookie consent?', answer: 'GDPR and some state laws require informed consent before using non-essential cookies. Cookie banners must be properly configured.' },
      { question: 'What is a data breach?', answer: 'Unauthorized access, disclosure, or loss of personal data. Most jurisdictions require breach notification to affected individuals and regulators.' },
      { question: 'What are the penalties?', answer: 'GDPR fines up to €20 million or 4% of global revenue; CCPA penalties up to $7,500 per violation. Plus potential lawsuits and reputational damage.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
